// extracted by mini-css-extract-plugin
export default {"xxlSizeMinWidth":"1536","xlSizeMaxWidth":"1535","lgSizeMaxWidth":"1024","mdSizeMaxWidth":"768","smSizeMaxWidth":"420","xsSizeMaxWidth":"360"};